'use strict';

var React = require('react');
require('../../theme/breakpoints.js');
var useClickAway = require('../../hooks/useClickAway.js');
require('imask');
var useRefAndForward = require('../../hooks/useRefAndForward.js');
require('resize-observer-polyfill');
var component$2 = require('../Divider/component.js');
var component$1 = require('../Icon/component.js');
require('../Tooltip/component.js');
var component = require('../Portal/component.js');
var styles = require('./styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const Drawer = React.forwardRef(({ children, isOpened, onOpenedChange, position, header, divider, maxWidth, closeIcon, ...props }, ref) => {
    const drawerRef = useRefAndForward.useRefAndForward(null, ref);
    useClickAway.useClickAway({
        containerRefs: [drawerRef],
        listener: React.useCallback(() => {
            if (isOpened)
                onOpenedChange(false);
        }, [isOpened, onOpenedChange]),
    });
    return (React__default.default.createElement(component.Portal, null,
        React__default.default.createElement(styles.Styled.Drawer, { ...props, ref: drawerRef, isOpened: isOpened, position: position, maxWidth: maxWidth },
            React__default.default.createElement(styles.Styled.Header, null,
                React__default.default.createElement("div", null, header),
                React__default.default.createElement(styles.Styled.CloseWrapper, { role: "button", "aria-label": "close", onClick: () => onOpenedChange(false) }, closeIcon || React__default.default.createElement(component$1.Icon, { name: "clear-filled" }))),
            divider || React__default.default.createElement(component$2.Divider, null),
            React__default.default.createElement(styles.Styled.Body, null, children))));
});

exports.Drawer = Drawer;
//# sourceMappingURL=component.js.map
